module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs"
  }, _vm._l((_vm.langs), function(lang) {
    return _c('a', {
      staticClass: "tabs__link",
      class: {
        'tabs__link--active': lang === _vm.current
      },
      on: {
        "click": function($event) {
          _vm.select(lang)
        }
      }
    }, [_vm._v(_vm._s(lang))])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7ba8044"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/LangSwitcher.vue
// module id = 68
// module chunks = 0